import { fetchAdminUserBuilds } from '@/api/admin';
import BuildCard from '@/components/build/build-card';
import BuildLogViewer from '@/components/build/build-log-viewer';
import BuildStageStepper from '@/components/build/build-stage-stepper';
import { Spinner } from '@/components/ui/spinner';
import type { IAdminBuild } from '@/entities/admin-user.entity';
import { getActiveBuild } from '@/entities/build.entity';
import { useBuildSubscription } from '@/hooks/use-build-subscription';
import { useEffect, useState } from 'react';

interface BuildsTabProps {
	profileId: number;
}

export default function BuildsTab({ profileId }: BuildsTabProps) {
	const [builds, setBuilds] = useState<IAdminBuild[]>([]);
	const [loading, setLoading] = useState(true);
	const activeBuild = getActiveBuild(builds);
	const { progress: liveProgress, logs } = useBuildSubscription(activeBuild?.id);

	useEffect(() => {
		let cancelled = false;
		fetchAdminUserBuilds(profileId)
			.then(data => {
				if (!cancelled) setBuilds(data);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [profileId]);

	if (loading) {
		return (
			<div className='flex justify-center py-8'>
				<Spinner />
			</div>
		);
	}

	if (builds.length === 0) {
		return <div className='text-center text-muted-foreground text-sm py-8'>Билдов нет</div>;
	}

	return (
		<div className='flex flex-col gap-3'>
			{activeBuild ? (
				<div className='rounded-xl border border-chart-5/30 bg-chart-5/10 p-4 flex flex-col gap-3'>
					<div>
						<p className='font-medium text-sm'>Активная сборка</p>
						<p className='text-xs text-muted-foreground'>{activeBuild.appName || activeBuild.id}</p>
					</div>
					<BuildStageStepper currentStage={liveProgress?.stage ?? activeBuild.builderStage} />
					<BuildLogViewer lines={logs} />
				</div>
			) : null}

			{builds.map(build => (
				<BuildCard key={build.id} build={build} adminLogs />
			))}
		</div>
	);
}
